module.exports = __webpack_public_path__ + "static/media/wav-icon.c5eac2e6.svg";